// Styles
import { Icon } from '../../common/components';
import { HealthCheckStatusWrapper } from './HealthCheckStatusStyles';
import * as variables from '../../common/styles/variables';
import { CircleCheckThin, WarningTriangleRed, WarningTriangleYellow, LoadingBar } from '../icons';
import { useEffect, useState } from 'react';
import { getHealthCheckStatus } from '../../common/api/healthCheckApi';
import { useAuthState } from '../../providers/authProvider';

type HealthCheckStatusProps = {
  display: string;
  apiUrl: string;
  refresh: boolean;
  refreshTime: any;
  handleStatusClick: Function;
  handleStatusSet: Function;
};

const defaultProps = {
  display: '',
  refresh: false,
  refreshTime: undefined,
  handleStatusClick: undefined,
  handleStatusSet: undefined,
};

export const HealthCheckStatus = (props: HealthCheckStatusProps) => {
  const [status, setStatus] = useState<string>('Pending');
  const [unhealthyStatus, setUnhealthyStatus] = useState<boolean>(false);
  const [unhealthyDescription, setUnhealthyDescription] = useState<Array<any>>([]);

  const authContext = useAuthState();

  useEffect(() => {
    loadData();
  }, [props.refreshTime]);

  const loadData = async () => {
    const tempResult = await getHealthCheckStatus(process.env.REACT_APP_API_SERVICES_URL, props.apiUrl, authContext);

    if (tempResult) {
      setStatus(tempResult.status);
      props.handleStatusSet(tempResult.status);

      if (tempResult.status === 'Unhealthy') {
        setUnhealthyStatus(true);
        handleUnhealthyStatusDescription(tempResult);
      }
    } else {
      setStatus('Pending');
    }
  };

  const getIcon = (value: any) => {
    switch (value) {
      case 'Healthy':
        return CircleCheckThin;
      case 'Degraded':
        return WarningTriangleYellow;
      case 'Unhealthy':
        return WarningTriangleRed;
      default:
        return LoadingBar;
    }
  };

  const handleUnhealthyStatusDescription = (unhealthyResult: any) => {
    if (unhealthyResult.entries) {
      Object.keys(unhealthyResult.entries).forEach(key => {
        if (unhealthyResult.entries[key].status === 'Unhealthy') {
          setUnhealthyDescription([
            ...unhealthyDescription,
            {
              entry: key,
              error: unhealthyResult.entries[key].description
                ? unhealthyResult.entries[key].description
                : 'Unknown error',
            },
          ]);
        }
      });
    } else {
      setUnhealthyDescription([
        ...unhealthyDescription,
        {
          entry: unhealthyResult.code,
          error: unhealthyResult.message,
        },
      ]);
    }
  };

  const handleStatusClick = () => {
    props.handleStatusClick(unhealthyDescription);
  };

  return (
    <HealthCheckStatusWrapper>
      <div>
        <div className='container pb-4'>
          <div className='left'>{props.display}</div>
          <div className='right'>
            <Icon icon={getIcon(status)} size={variables.iconSizeSmall} />{' '}
            {unhealthyStatus && (
              <div
                className='unhealthyStatus'
                onClick={event => {
                  event.preventDefault();
                  handleStatusClick();
                }}
              >
                {status}
              </div>
            )}
            {!unhealthyStatus && status}
          </div>
        </div>
      </div>
    </HealthCheckStatusWrapper>
  );
};

HealthCheckStatus.defaultProps = defaultProps;
